export function toPage(){
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    return 'appIndex';
  } else {
    return 'index';
  }
}



// WEBPACK FOOTER //
// ./src/utils/rem.js